import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import { DataSocieteAPI } from '../../data/DataSocieteAPI';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAPI } from '../ComboBox/ComboBoxAPI';
import { EUIDialog } from '../EUI/EUIDialog';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerSociete } from '../Picker/PickerSociete';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        -
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListSocieteAPI extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = {};
        this._isSortedDescending = false;
        this._sortedColumn = "IdSociete";
        this._objetState = {
            groups: [],
            items: [],
            itemActif: {},
            idsAPIsSelectionnees: [],
            idSocieteSelectionnee: 0,
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            compact
            groupProps={{ showEmptyGroups: true }}
            groups={this.state.groups}
            items={this.state.items}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des inscriptions en cours..."
        });

        let chargementSocietesAPIs = DataSocieteAPI._chargementSocietesAPIs(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementSocietesAPIs
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let listeInscriptions = responseFetch.reponseAPIobjet || [];
                    listeInscriptions.sort((a, b) => { return a.idSociete - b.idSociete; });
                    const stateTemp = {
                        groups: this._getGroups(listeInscriptions),
                        items: listeInscriptions
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    this.setState({
                        groups: [],
                        items: []
                    });
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });
    };

    _getGroups = (listeInscriptions) => { // Une inscription == un enregistrement dans la table Societe_API

        const inscriptionsGroupeesParSociete = listeInscriptions.reduce((memo, inscription) => {
            const idSociete = inscription.idSociete;
            if (!memo[idSociete])
                memo[idSociete] = [];
            memo[idSociete].push(inscription);
            return memo;
        }, {});

        let groups = [];
        let startIndex = 0
        for (const [idSociete, inscriptions] of Object.entries(inscriptionsGroupeesParSociete)) {
            const { nom } = inscriptions[0];
            const count = inscriptions.length;
            groups.push({ key: idSociete, name: nom, startIndex, count });
            startIndex += count;
        };

        return groups;

    };

    _getColumns = () => {
        return [
            {
                key: "idAPI",
                minWidth: 20,
                maxWidth: 20,
                name: "",
                onRender: (item) => {
                    const idAPI = item.idAPI;
                    return <span title={idAPI} className="badge badge-secondary">{idAPI}</span>;
                }
            },
            {
                key: "nomAPI",
                name: "API",
                minWidth: 250,
                maxWidth: 250,
                onRender: (item) => {
                    const nomAPI = item.nomAPI;
                    return <span title={nomAPI}>{nomAPI}</span>;
                }
            },
            {
                key: "description",
                name: "Description",
                onRender: (item) => {
                    const description = item.description;
                    return <span title={description}>{description}</span>;
                }
            },
            {
                key: "nomAction",
                name: "Action",
                onRender: (item) => {
                    const nomAction = item.nomAction;
                    return <span title={nomAction}>{nomAction}</span>;
                }
            },
            {
                key: "nomTable",
                name: "Table",
                onRender: (item) => {
                    const nomTable = item.nomTable;
                    return <span title={nomTable}>{nomTable}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: "desinscrire",
                minWidth: 25,
                maxWidth: 25,
                name: "Consulter",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialogDesinscription(true, item)}
                        title="Supprimer l'inscription à cette API"
                    />;
                }
            }
        ];
    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }];
    };

    _getItems = () => {
        return [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
            {
                key: "inscription",
                name: "Inscrire une société à une API",
                iconProps: { iconName: "Add" },
                onClick: this._toggleDialogInscription(true)
            }
        ];
    };

    _inscrireSociete = () => {
        this._toggleDialogInscription(false)();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Inscription en cours..."
        });

        const { idSocieteSelectionnee, idsAPIsSelectionnees } = this.state;
        DataSocieteAPI._onEnregistrementMultipleSocieteAPI(idSocieteSelectionnee, idsAPIsSelectionnees)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _desinscrireSociete = () => {
        this._toggleDialogDesinscription(false)();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désinscription en cours..."
        });

        const { idSociete, idAPI } = this.state.itemActif;
        DataSocieteAPI._onSuppressionSocieteAPI(idSociete, idAPI)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _toggleDialogDesinscription = (isOpen, item) => () => {
        this.setState({
            afficherDialogDesinscription: isOpen,
            itemActif: item || {}
        });
    };

    _toggleDialogInscription = (isOpen) => () => {
        this.setState({
            afficherDialogInscription: isOpen,
            idsAPIsSelectionnees: [],
            idSocieteSelectionnee: 0
        });
    };

    componentDidMount = () => { this._chargementDonnees(); };

    render = () => {

        const content = this._creationContent();
        const { afficherDialogDesinscription, afficherDialogInscription, idsAPIsSelectionnees, itemActif, idSocieteSelectionnee } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="confirm" onClick={this._inscrireSociete} text="Confirmer" disabled={!(idSocieteSelectionnee && idsAPIsSelectionnees.length)} />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogInscription(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogInscription}
                onDismiss={this._toggleDialogInscription(false)}
                titre="Inscription"
            >
                <PickerSociete onChange={(societe) => this.setState({ idSocieteSelectionnee: societe.idSociete })} selectedKey={idSocieteSelectionnee} required />
                <ComboBoxAPI
                    onChange={(event, option, _, value, item) => {
                        const index = idsAPIsSelectionnees.indexOf(option.key);

                        let ids = [...idsAPIsSelectionnees];
                        if (option.selected && index === -1) ids.push(option.key);
                        else ids.splice(index, 1);

                        this.setState({ idsAPIsSelectionnees: ids })
                    }}
                    required
                    selectedKey={idsAPIsSelectionnees}
                />
            </EUIDialog>;

            <EUIDialog
                buttons={[
                    <PrimaryButton key="confirm" onClick={this._desinscrireSociete} text="Confirmer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogDesinscription(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogDesinscription}
                message={`Confirmez-vous la désinscription de la société ${itemActif.nom} de l'API ${itemActif.nomAPI} ?`}
                onDismiss={this._toggleDialogDesinscription(false)}
                titre="Désinscription"
            />

        </Fragment>;

    };

};